<template>
    <v-card class="mt-2 ml-2 mr-2">
        <FArticleCategTable class="pl-2 pr-2" ref="refFArticleCategTable"/>
    </v-card>
  </template>
  
  <script>
  import FArticleCategTable from "@/components/admin-e-library/admin-article-categ/FArticleCategTable.vue";
  
  export default {
    name: "FArticleCategView",
    components: {
      FArticleCategTable
    },
    data() {
      return {
        tabTitle: 'FArticleCateg'
      }
    },
    computed: {
    },
    methods: {
      tabFArticleCategClick(){
        this.$refs.refFArticleCategTable.fetchParent()
      },
  
    },
  
  
  }
  </script>
  
  <style scoped>
  </style>